{
  "slug": "what-is-the-average-iq",
  "title": "What is the average IQ?",
  "description": "See why the average IQ is usually 100, how standard deviations and percentiles work, and how to interpret comparisons responsibly.",
  "summary": "On most modern IQ scales, the average is set to 100. Roughly two thirds of the reference population fall between 85 and 115.",
  "sections": [
    {
      "heading": "Why the average is 100",
      "paragraphs": [
        "IQ scales are standardized rather than based on a fixed number of correct answers. Publishers transform raw results so the reference group has a mean of 100. Tests are periodically renormed as populations and educational experiences change.",
        "A score near 100 means performance close to the middle of the selected norm group—not that someone answered 100 questions or possesses a fixed quantity of intelligence."
      ]
    },
    {
      "heading": "The common 85–115 range",
      "paragraphs": [
        "With a standard deviation of 15, about 68% of a normal distribution lies from 85 to 115, and about 95% from 70 to 130. These are approximations.",
        "Percentiles can be easier to understand: 100 is near the 50th percentile, 115 near the 84th, and 85 near the 16th."
      ]
    },
    {
      "heading": "Use comparisons carefully",
      "paragraphs": [
        "A score needs appropriate age norms and a current test version. Language, education, health, and context matter. Cross-country or demographic comparisons are especially sensitive to sampling and methodology.",
        "For an individual, a confidence interval and subtest profile are more useful than treating the total as perfectly precise."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Is 100 a good IQ score?",
      "answer": "A score of 100 is at the center of the norm group and represents typical performance on the abilities assessed."
    },
    {
      "question": "What percentage of people score above 100?",
      "answer": "Approximately half score above 100 and half below it, although real norm distributions are not perfectly symmetrical."
    }
  ],
  "related": ["iq-score-ranges-explained", "what-does-an-iq-of-120-mean", "how-is-iq-measured"]
}
